import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { ModuleFE_MouseInteractivity, mouseInteractivity_PopUp, ProtoComponent } from '@nu-art/thunderstorm-frontend/index';
import { EditableDBItemV3, } from '@nu-art/thunderstorm-frontend/editable-item';
import { TS_HorizontalWorkspace, TS_Workspace } from '@nu-art/ts-workspace-frontend/index';
import { workspaceKey_OrderEditor } from './workspace-config.js';
import { EditorWrapper_Order } from './presenters/EditorWrapper_Order.js';
import { SearchSelector_BaseManagerUI } from '@app/styles/frontend/ui/ui-manager/Selector_Base/SearchSelector_BaseManagerUI';
import { getActionManagerSearchableItems } from './consts.js';
import { cloneObj, DefaultNewItemId, exists, resolveContent } from '@nu-art/ts-common';
import { cleanAction, cleanOrderGroup, DBDef_Action, DBDef_OrderGroup } from '@app/pathway-shared';
import { ModuleFE_Action, ModuleFE_OrderGroup } from '../../_entity.js';
import { Editor_OrderGroup } from '../Editor_OrderGroup/Editor_OrderGroup.js';
export class Page_ActionManager extends ProtoComponent {
    // ######################## Life Cycle ########################
    static defaultProps = {
        keys: ['selected', 'searchItem'],
    };
    deriveStateFromProps(nextProps, state) {
        state.searchItems ??= getActionManagerSearchableItems();
        //Get selectedSearchItem from url
        const selected = this.getQueryParam('selected', {});
        //Get selected search item
        state.selectedSearchItem = undefined;
        for (const searchItem of state.searchItems) {
            const selectedId = selected[searchItem.type];
            if (!exists(selectedId))
                continue;
            state.selectedSearchItem = { type: searchItem.type, id: selectedId };
            break;
        }
        return state;
    }
    // ######################## Logic ########################
    onSearchItemSelected = (item) => {
        const selected = { ...this.getQueryParam('selected', {}) };
        //Clear all selections under this manager
        this.state.searchItems.forEach(searchItem => delete selected[searchItem.type]);
        //Set the selected item
        selected[item.type] = item.id;
        this.setQueryParams({
            selected: selected,
            searchItem: item.type, //Switch the filters in the search panel to the item type
        });
    };
    createNewItem = (dbKey) => {
        ModuleFE_MouseInteractivity.hide(mouseInteractivity_PopUp);
        this.onSearchItemSelected({ type: dbKey, id: DefaultNewItemId });
    };
    getEditable = (module, newItemBase) => {
        const id = this.state.selectedSearchItem?.id;
        if (!id)
            return;
        const selectedItem = module.cache.unique(id) ?? cloneObj(resolveContent(newItemBase));
        const editable = new EditableDBItemV3(selectedItem, module);
        editable.setAutoSave(selectedItem._id !== DefaultNewItemId);
        editable.setDebounceTimeout(300);
        editable.setOnSaveCompleted(item => {
            //If the item is newly created, simulate selection for it
            if (id === DefaultNewItemId)
                return this.onSearchItemSelected({ type: module.dbDef.dbKey, id: item._id });
            //Item is not newly created, re-render
            this.forceUpdate();
        });
        return editable;
    };
    deselectItem = (dbKey) => {
        const selected = { ...this.getQueryParam('selected', {}) };
        delete selected[dbKey];
        this.setQueryParam('selected', selected);
    };
    // ######################## Render ########################
    render() {
        return _jsx(TS_Workspace, { workspaceKey: workspaceKey_OrderEditor, renderers: {
                horizontalSpace: TS_HorizontalWorkspace,
            }, instances: {
                selector: () => this.renderList(),
                presenter: () => this.renderEditor(),
            } });
    }
    renderList = () => {
        return _jsx(SearchSelector_BaseManagerUI, { buttons: [{
                    label: 'Add New',
                    action: (e) => {
                        const buttonBox = e.currentTarget.getBoundingClientRect();
                        const model = {
                            id: 'advisor-context-editor__add-new-popup',
                            originPos: {
                                x: buttonBox.x + buttonBox.width + 10,
                                y: buttonBox.y + (buttonBox.height / 2),
                            },
                            modalPos: { x: 1, y: 0 },
                            content: () => {
                                return _jsx(_Fragment, { children: this.state.searchItems.map(searchItem => _jsx("div", { onClick: () => this.createNewItem(searchItem.type), children: searchItem.entityLabel }, searchItem.type)) });
                            },
                        };
                        ModuleFE_MouseInteractivity.showContent(model);
                    }
                }], searchItems: this.state.searchItems, onSearchItemSelected: this.onSearchItemSelected, selectedItem: this.state.selectedSearchItem });
    };
    renderEditor = () => {
        switch (this.state.selectedSearchItem?.type) {
            case DBDef_Action.dbKey:
                return this.renderEditor_Action();
            case DBDef_OrderGroup.dbKey:
                return this.renderEditor_OrderGroup();
            default:
                return _jsx(_Fragment, {});
        }
    };
    renderEditor_Action = () => {
        const editable = this.getEditable(ModuleFE_Action, cleanAction);
        if (!editable)
            return _jsx(_Fragment, {});
        return _jsx(EditorWrapper_Order, { editable: editable, deselectItem: () => this.deselectItem(DBDef_Action.dbKey) });
    };
    renderEditor_OrderGroup = () => {
        const editable = this.getEditable(ModuleFE_OrderGroup, cleanOrderGroup);
        if (!editable)
            return _jsx(_Fragment, {});
        return _jsx(Editor_OrderGroup, { editable: editable, deselect: () => this.deselectItem(DBDef_OrderGroup.dbKey) });
    };
}
//# sourceMappingURL=Page_ActionManager.js.map